import moment from 'moment';
import { product_list_localstorage } from './confg';

export function notNullAndUndefined(value) {
    return typeof value !== 'undefined' && value !== null && value !== '';
}

/** معادل تومانی مقدار گرم طلا (gold_price بر حسب ریال است) */
export function getGoldGramDeductionToman(gramUsage, goldPriceRial) {
    return Math.round((parseFloat(gramUsage) || 0) * ((parseFloat(goldPriceRial) || 0) / 10));
}

/** کسر موجودی گرمی از مبلغ (منفی نمی‌شود) */
export function applyGoldGramDeduction(amount, gramUsage, goldPriceRial) {
    const deduction = getGoldGramDeductionToman(gramUsage, goldPriceRial);
    return Math.max(0, (parseFloat(amount) || 0) - deduction);
}

export const parseFloatNull = function (x) {
    let res = (x === null) ? 0 : parseFloat(x);
    return res;
}

export const validatePersian = function (value) {
    // var p = /^\s*([\u0600-\u06FF\s]*\-*)*\s*$/;
    var p = /^[\u0600-\u06FF\s\-]+$/;

    if (!p.test(value)) {
        return false
    }

    return true;
}

export function persianConvert(s) {
    return s.toString().replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
}

export function getAllUrlParams(url) {
    // get query string from url (optional) or window
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {

        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];

        // split our query string into its component parts
        var arr = queryString.split('&');

        for (var i = 0; i < arr.length; i++) {
            // separate the keys and the values
            var a = arr[i].split('=');

            // set parameter name and value (use 'true' if empty)
            var paramName = a[0];
            var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

            // (optional) keep case consistent
            paramName = paramName.toLowerCase();
            if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

            // if the paramName ends with square brackets, e.g. colors[] or colors[2]
            if (paramName.match(/\[(\d+)?\]$/)) {

                // create key if it doesn't exist
                var key = paramName.replace(/\[(\d+)?\]/, '');
                if (!obj[key]) obj[key] = [];

                // if it's an indexed array e.g. colors[2]
                if (paramName.match(/\[\d+\]$/)) {
                    // get the index value and add the entry at the appropriate position
                    var index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else {
                    // otherwise add the value to the end of the array
                    obj[key].push(paramValue);
                }
            } else {
                // we're dealing with a string
                if (!obj[paramName]) {
                    // if it doesn't exist, create property
                    obj[paramName] = paramValue;
                } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                    // if property does exist and it's a string, convert it to an array
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                } else {
                    // otherwise add the property
                    obj[paramName].push(paramValue);
                }
            }
        }
    }

    return obj;
}

export const calculate_price = (gold, formoula, w, discount = 0) => {
    let p = gold;
    let { o, k, t, b, r } = formoula;

    o = o !== null ? parseFloat(o) : 0;
    k = k !== null ? parseFloat(k) : 0;
    t = t !== null ? parseFloat(t) : 0;
    b = b !== null ? parseFloat(b) : 0;
    r = r !== null ? parseFloat(r) : 0;

    if (hasDiscount(discount)) {
        let dis = k - discount['percent'];
        if (k > 0) {
            k = dis;
        }
    }

    let price = (((w * p * ((k / 100) + 1) * b) + (w * o) + r) * t);

    return Math.ceil(price / 10000) * 10000
};

export const calculate_price_without_dis = (gold, formoula, w, discount) => {
    let { o, k, t, b, r } = formoula;

    o = o !== null ? parseFloat(o) : 0;
    k = k !== null ? parseFloat(k) : 0;
    t = t !== null ? parseFloat(t) : 0;
    b = b !== null ? parseFloat(b) : 0;
    r = r !== null ? parseFloat(r) : 0;

    let p = gold;
    let price = (((w * p * ((k / 100) + 1) * b) + (w * o) + r) * t);

    return (Math.ceil(price / 10000) * 10000)
};

/**
 *
 * @param obj discount
 * @returns {boolean}
 */
export const hasDiscount = function (obj) {
    return typeof obj !== "undefined" && obj.sale_type !== 'normal' && typeof obj.percent !== 'undefined' && obj.percent !== "" && obj.percent > 0 && moment(obj.start_date).isBefore(moment()) && moment(obj.expire_date).isAfter(moment())
};

export const isVariantInStock = (variant) => {
    if (!variant) {
        return false;
    }

    const { is_exist } = variant;
    return is_exist === 1 || is_exist === true || is_exist === '1';
};

export const getInStockWeightOptions = (products) => {
    if (!Array.isArray(products)) {
        return [];
    }

    return unique(
        products
            .filter((item) => item && item.weight && isVariantInStock(item))
            .map((item) => ({
                id: item.id,
                weight: item.weight,
                barcode: item.barcode,
                is_exist: item.is_exist,
                valuesFormula: item.valuesFormula,
            })),
        'weight',
    ).sort((a, b) => parseFloat(a.weight) - parseFloat(b.weight));
};

export const isVariantInCartList = (cartProducts, variant) => {
    if (!variant || !Array.isArray(cartProducts) || cartProducts.length === 0) {
        return false;
    }

    const variantBarcode = variant.barcode != null ? +variant.barcode : null;
    const variantId = variant.id != null ? +variant.id : null;

    return cartProducts.some((item) => {
        if (variantId && +item.products_id === variantId) {
            return true;
        }

        if (variantBarcode != null && +item.products?.accounting_barcode === variantBarcode) {
            return true;
        }

        if (variantBarcode != null && +item.barcode === variantBarcode) {
            return true;
        }

        return false;
    });
};

export const guestCartCount = () => {
  try {
    const storage = localStorage.getItem(product_list_localstorage);
    if (!storage) return 0;
    const parsed = JSON.parse(storage);
    return Array.isArray(parsed) ? parsed.length : 0;
  } catch (error) {
    return 0;
  }
};

export const isVariantInOfflineCart = (variant) => {
    if (!variant || variant.barcode == null) {
        return false;
    }

    try {
        const storage = localStorage.getItem(product_list_localstorage);
        if (!storage) {
            return false;
        }

        const parsed = JSON.parse(storage);
        if (!Array.isArray(parsed)) {
            return false;
        }

        return parsed.some((item) => +item.barcode === +variant.barcode);
    } catch (error) {
        return false;
    }
};

export const getOfflineCartBarcode = (item) => {
    if (item?.barcode == null || item?.barcode === '') {
        return null;
    }

    return +item.barcode;
};

export const findOfflineCartVariant = (item) => {
    const barcode = getOfflineCartBarcode(item);
    const album = item?.product;

    if (!album || barcode == null) {
        return null;
    }

    if (Array.isArray(album.products)) {
        return album.products.find((variant) => +variant.barcode === barcode) || null;
    }

    return album.product || null;
};

export const transformOfflineCartItemForDisplay = (obj) => {
    const variant = findOfflineCartVariant(obj);
    const album = obj?.product || {};
    const barcode = getOfflineCartBarcode(obj);

    return {
        discount: album.discount,
        final_price: obj.price,
        customers_basket_id: barcode,
        formula: variant?.valuesFormula || album.products?.[0]?.valuesFormula,
        pictures: album.pictures,
        products: {
            album_id: album.id || obj.album_id,
            accounting_name_product: variant?.name || album.products?.[0]?.name,
            accounting_name_model: variant?.name || album.products?.[0]?.name,
            accounting_barcode: variant?.barcode ?? barcode,
            accounting_weight: variant?.weight,
            weight: variant?.weight,
        },
    };
};

export const isSameOfflineCartItem = (item, removeId) => {
    if (removeId == null || removeId === '') {
        return false;
    }

    const itemBarcode = getOfflineCartBarcode(item);

    if (itemBarcode != null) {
        return itemBarcode === +removeId;
    }

    const productId = item?.product?.id || item?.id || item?.customers_basket_id;
    return productId === removeId;
};

export const buildProductQuery = (weight, barcode) => {
    const params = new URLSearchParams();

    if (weight != null && weight !== '') {
        params.set('weight', weight);
    }

    if (barcode != null && barcode !== '') {
        params.set('barcode', barcode);
    }

    const query = params.toString();
    return query ? `?${query}` : '';
};

export const buildProductPath = (albumId, name, weight, barcode) => {
    const slug = name ? String(name).split(' ').join('-') : '';
    return `/products/${albumId}/${slug}${buildProductQuery(weight, barcode)}`;
};

export const unique = (a, field = null) => {
    if (field === null)
        return a.filter(function (item, i, ar) { return ar.indexOf(item) === i; })
    else {
        let flags = [], output = [], l = a.length, i;

        for (i = 0; i < l; i++) {
            if (flags[a[i][field]]) continue;
            flags[a[i][field]] = true;
            output.push(a[i]);
        }

        return output
    }
}